import * as ActionTypes from '../restore';
import { CALL_API } from '../../../middleware/api';
function fetchRestore() {
    var _a;
    return _a = {
            type: ActionTypes.RESTORE
        },
        _a[CALL_API] = {
            endpoint: '/api/gambler/reauth',
            method: 'get',
            types: [ActionTypes.SUCCESS_RESTORE, ActionTypes.FAILURE_RESTORE]
        },
        _a;
}
export function loadRestore(data) {
    return function (dispatch) {
        return dispatch(fetchRestore(data));
    };
}



// WEBPACK FOOTER //
// ./src/actions/auth/creators/restore.js